import { ITrainingCentreListItem } from 'partner360/components/trainingCentre/components/trainingCentrePopup/components/trainingCentreContent/models'
import { ITrainingTopic } from 'partner360/models/trainingCentre/ITrainingCentre'

import { ReactComponent as BookIcon } from '../../../../../assets/book.svg'

export const getTopicListItems = (
  selectedRtm: string | null,
  topics: ITrainingTopic[],
  onSelectTopic: (topicId: string) => void
): ITrainingCentreListItem[] => {
  return topics
    .filter((topic) => topic.RtmId === selectedRtm)
    .sort((a, b) => a.Order - b.Order)
    .map((topic) => ({
      id: topic.Id,
      title: topic.Title,
      icon: BookIcon,
      onClick: () => onSelectTopic(topic.Id),
    }))
}
